import { toRepeatQuery } from './queryString'
import { GetErpHistoriesReq } from './types'

/**
 * EST05(신규) 재고이동내역조회 화면이 쓰는 엔드포인트.
 *
 * 동작별 배선 (LOGISPRD-10669 기준표):
 * | 동작            | 2.0 API                                                 | 1.0 API                          | 비고                      |
 * |-----------------|---------------------------------------------------------|----------------------------------|---------------------------|
 * | 화면            | —                                                       | —                                | FE 전용 신규 페이지(est05), 기존 est03(iframe) 유지 |
 * | 조회(HEAD)      | `GET /api/v1/stock-transfer/erp-histories/summary`      | /api/grid/search (EST03_HEAD)    | LOGISPRD-9590             |
 * | 조회(ITEM)      | `GET /api/v1/stock-transfer/erp-histories`              | /api/grid/search (EST03_ITEM)    | LOGISPRD-9590             |
 * | 다운로드(HEAD)  | `GET /api/v1/stock-transfer/erp-histories/summary/excel`| — (1.0 은 FE 로컬 ag-Grid 엑셀)  | LOGISPRD-9591 (서버 엑셀) |
 * | 다운로드(ITEM)  | `GET /api/v1/stock-transfer/erp-histories/excel`        | — (〃)                           | LOGISPRD-9591 (서버 엑셀) |
 */
export const ERP_HISTORIES_URL = '/api/v1/stock-transfer/erp-histories'
export const ERP_HISTORY_SUMMARIES_URL = `${ERP_HISTORIES_URL}/summary`
export const ERP_HISTORY_SUMMARIES_EXCEL_URL = `${ERP_HISTORY_SUMMARIES_URL}/excel`
export const ERP_HISTORY_ITEMS_EXCEL_URL = `${ERP_HISTORIES_URL}/excel`

/** HEAD 조회 요청 URL. */
export const buildErpHistorySummariesUrl = (params: GetErpHistoriesReq) => `${ERP_HISTORY_SUMMARIES_URL}?${toRepeatQuery(params)}`

/** ITEM 조회 요청 URL. */
export const buildErpHistoryItemsUrl = (params: GetErpHistoriesReq) => `${ERP_HISTORIES_URL}?${toRepeatQuery(params)}`

/** 엑셀 다운로드 사유 — 나눠 보내면 BE 가 `{코드}_{상세}` 로 합쳐 EXPORT 감사에 남긴다(LOGISPRD-15563). */
export type ExcelDownloadReason = { reasonCode: string; detailedReason: string }

/** HEAD 엑셀 다운로드 URL. blob 으로 받아 저장한다. */
export const buildErpHistorySummariesExcelUrl = (params: GetErpHistoriesReq, reason: ExcelDownloadReason) =>
  `${ERP_HISTORY_SUMMARIES_EXCEL_URL}?${toRepeatQuery({ ...params, ...reason })}`

/** ITEM 엑셀 다운로드 URL. */
export const buildErpHistoryItemsExcelUrl = (params: GetErpHistoriesReq, reason: ExcelDownloadReason) =>
  `${ERP_HISTORY_ITEMS_EXCEL_URL}?${toRepeatQuery({ ...params, ...reason })}`
